<template>
  <div class="success_page">
    <div v-if="isWithdrawalResult" class="withdraw_result_page">
      <Tabbar :title="$t('basicLevel.cashOut')" :back="back" />
      <div class="result_content">
        <div class="result_info">
          <div class="result_status">
            <img class="result_icon" src="../assets/cashout_success_pic.png" alt="" />
            <div class="result_title">{{ $t('withdrawAccount.requestSubmitted') }}</div>
          </div>
          <div class="result_amount_block">
            <div class="result_amount">
              <span>$</span>
              <span>{{ formattedAmount }}</span>
            </div>
            <div class="result_eta">{{ $t('withdrawAccount.cashOutSuccessNote') }}</div>
          </div>
        </div>
        <CommonBtn class="result_back_btn" :text="backBtnText" :on-click="back" />
      </div>
    </div>
    <div v-else class="success_area">
      <div class="success_con">
        <img class="success_img" src="../assets/cashout_success_pic.png" alt="" />
        <div class="success_info">
          <p>{{ $t('account.completed') }}.</p>
        </div>
        <div class="success_back" @click="back">{{ $t('common.back') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import CommonBtn from '@/components/CommonBtn'
import { postReportLog } from '@/utils/log'

export default {
  name: 'Success',
  components: {
    Tabbar,
    CommonBtn
  },
  data() {
    return {
      eventId: undefined,
      countdown: 3,
      timer: null
    }
  },
  computed: {
    isWithdrawalResult() {
      return this.$route.name === 'WithdrawalResult'
    },
    formattedAmount() {
      const value = parseFloat(this.$route.query.amount)
      if (isNaN(value)) {
        return '0'
      }
      return new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 0
      }).format(value)
    },
    backBtnText() {
      return `${this.$t('common.back')}(${this.countdown}s)`
    }
  },
  created() {
    this.eventId = this.$route.params.eventId
    if (this.isWithdrawalResult) {
      postReportLog({
        log_id: '440',
        extra: {
          page: 'withdrawal_result',
          amount: this.$route.query.amount || ''
        }
      })
      this.startCountdown()
    }
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    startCountdown() {
      this.clearTimer()
      this.countdown = 3
      this.timer = setInterval(() => {
        if (this.countdown <= 1) {
          this.back()
          return
        }
        this.countdown -= 1
      }, 1000)
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    back() {
      this.clearTimer()
      if (this.eventId === 1) {
        this.$router.replace({
          name: 'MyLinkedAccount'
        })
      } else {
        this.$router.replace({
          name: 'Home'
        })
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

.success_page {
  height: 100%;
}

.withdraw_result_page {
  min-height: 100%;
  background: #fff;
}

.result_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.31rem;
  padding: 0.42rem 0.16rem 0;
}

.result_info {
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
  width: 100%;
}

.result_status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.08rem;
  padding: 0 0.52rem;
  width: 100%;
  box-sizing: border-box;
}

.result_icon {
  width: 0.62rem;
  height: 0.62rem;
  display: block;
  flex-shrink: 0;
}

.result_title {
  width: 100%;
  color: #2f2f2f;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.28rem;
  word-break: break-word;
}

.result_amount_block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.11rem;
  padding: 0 0.2rem;
  width: 100%;
  box-sizing: border-box;
}

.result_amount {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.04rem;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.4rem;
  direction: ltr;
  white-space: nowrap;
}

.result_eta {
  width: 100%;
  color: #3fbb70;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
  word-break: break-word;
}

.result_back_btn {
  width: 100% !important;
  font-size: 0.16rem !important;
  line-height: 0.24rem;
}

.success_area {
  width: 100%;
  height: calc(100% - 2rem);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.success_con {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 0.18rem;
}

.success_img {
  width: 0.8rem;
  height: 0.8rem;
  margin-bottom: 0.32rem;
  margin-top: 0.8rem;
}

.success_info {
  width: 100%;
  text-align: center;
  font-size: 0.2rem;
  color: #3fbb70;
  font-family: 'PingFang SC';
}

.success_back {
  margin-top: 1.28rem;
  border-radius: 0.365rem;
  width: 3.39rem;
  height: 0.5rem;
  color: #fff;
  font-size: 0.16rem;
  box-sizing: border-box;
  font-weight: 600;
  background: #3fbb70;
  line-height: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Success.vue